<script lang="ts" setup>
defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  heightInPx: {
    type: Number,
    default: 63 * 3,
  },
});

const content = ref<HTMLDivElement | null>(null);
const shouldCollapse = ref(false);
const isCollapsed = ref(true);

onMounted(() => {
  shouldCollapse.value = content?.value ? content.value.offsetHeight > props.heightInPx : false;
});
</script>

<template>
  <div class="wrapper" v-bind="$attrs">
    <div class="content" :style="{ 'max-height': shouldCollapse && isCollapsed ? `${heightInPx}px` : '100%', overflow: 'hidden' }" ref="content">
      <slot />
    </div>
    <div class="fade" v-if="shouldCollapse && isCollapsed"></div>
  </div>
  <div class="action" v-if="shouldCollapse">
    <button class="button" type="button" @click="isCollapsed = !isCollapsed">
      {{ isCollapsed ? $t('show-more') : $t('show-less') }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/styles/tw-variables.scss';
@import '~/assets/styles/tw-mixins.scss';
@import '~/assets/styles/tw-form.scss';

.wrapper {
  width: 100%;
  display: block;
  position: relative;
}

.content {
  width: 100%;
  display: block;
  white-space: break-spaces;
  transition: all 0.5s ease-out-in;
}

.fade {
  left: 0;
  right: 0;
  bottom: 0;
  height: 1rem;
  position: absolute;
  background: linear-gradient(180deg, rgba($white, 0) 0%, rgba($white, 1) 100%);
}

.action {
  padding: 0.5rem 0;
}

.button {
  @include tw-link;
  color: $black;
}
</style>
